<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 11L20.512 17.191C21.296 17.761 20.893 19 19.925 19H4.075C3.107 19 2.704 17.761 3.488 17.191L12 11ZM12 11V10.031C12 9.425 12.412 8.897 13 8.75C13.588 8.603 14 8.075 14 7.469V6.965C14 5.88 13.103 5 12 5C10.913 5 10 5.895 10 7"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
